import React, { useEffect, useState } from "react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, PieChart, Pie, Cell, Legend, ResponsiveContainer,
} from "recharts";

const COLORS = ["#4e79a7", "#f28e2b", "#e15759", "#76b7b2"];

const VolunteersPerformance = () => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSummary();
  }, []);

  const fetchSummary = async () => {
    try {
      // const url = "http://localhost:8000/volunteers-performance"
      const url = 'https://api.mba-gris.stgafrica.org/volunteers-performance'
      // const url = "https://wtddhx7d-8000.uks1.devtunnels.ms/volunteers-performance";
      const response = await fetch(url);
      const data = await response.json();
      setSummary(data);
    } catch (error) {
      console.error("Error fetching performance summary:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div style={styles.loading}>Loading dashboard...</div>;
  if (!summary) return <div style={styles.loading}>No data available.</div>;

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>📊 Innovation Monitoring Dashboard</h1>

      {/* Summary Stats */}
      <div style={styles.summaryCards}>
        <div style={styles.card}>
          <h3>Total Submissions</h3>
          <p style={styles.cardValue}>{summary.total}</p>
        </div>
        <div style={styles.card}>
          <h3>Today</h3>
          <p style={styles.cardValue}>{summary.today}</p>
        </div>
        <div style={styles.card}>
          <h3>Yesterday</h3>
          <p style={styles.cardValue}>{summary.yesterday}</p>
        </div>
      </div>

      {/* Weekly Submissions */}
      <div style={styles.section}>
        <h2>📅 Weekly Submissions</h2>
        <div style={styles.chartCard}>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={summary.weekly}>
              <XAxis dataKey="week" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count" fill="#4e79a7" radius={[8, 8, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Gender and PwD */}
      <div style={styles.section}>
        <h2>👥 Demographics</h2>
        <div style={styles.pieRow}>
          <div style={styles.pieContainer}>
            <h4>Gender Distribution</h4>
            <ResponsiveContainer width="100%" height={200}>
              <PieChart>
                <Pie
                  data={summary.gender}
                  dataKey="value"
                  nameKey="label"
                  cx="50%"
                  cy="50%"
                  outerRadius={70}
                  label
                >
                  {summary.gender.map((_, i) => (
                    <Cell key={i} fill={COLORS[i % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>

          <div style={styles.pieContainer}>
            <h4>Disability (PwD)</h4>
            <ResponsiveContainer width="100%" height={200}>
              <PieChart>
                <Pie
                  data={summary.pwd}
                  dataKey="value"
                  nameKey="label"
                  cx="50%"
                  cy="50%"
                  outerRadius={70}
                  label
                >
                  {summary.pwd.map((_, i) => (
                    <Cell key={i} fill={COLORS[i % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* District Summary */}
      <div style={styles.section}>
        <h2>🏙️ Submissions by District</h2>
        <div style={styles.chartCard}>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={summary.districts}>
              <XAxis dataKey="district" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count" fill="#76b7b2" radius={[8, 8, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      {/* Volunteers Table */}
<div style={styles.section}>
  <h2>👤 Volunteer Performance Table</h2>
  <div style={styles.tableWrapper}>
    <table style={styles.table}>
      <thead>
        <tr>
          <th style={styles.th}>Volunteer ID</th>
          <th style={styles.th}>District</th>
          <th style={styles.th}>Total</th>
          <th style={styles.th}>Male</th>
          <th style={styles.th}>Female</th>
          <th style={styles.th}>PwD</th>
        </tr>
      </thead>
      <tbody>
        {summary.volunteers.map((v, idx) => (
          <tr key={idx}>
            <td style={styles.td}>{v.volunteer_ids}</td>
            <td style={styles.td}>{v.district || "Unknown"}</td>
            <td style={styles.td}>{v.total}</td>
            <td style={styles.td}>{v.male}</td>
            <td style={styles.td}>{v.female}</td>
            <td style={styles.td}>{v.pwd}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>

    </div>
  );
};

// ✅ Internal Styles (modernized)
const styles = {
  container: {
    padding: "40px",
    fontFamily: "'Segoe UI', sans-serif",
    backgroundColor: "#f5f7fa",
    color: "#333",
    minHeight: "100vh",
  },
  heading: {
    fontSize: "32px",
    fontWeight: 600,
    marginBottom: "30px",
  },
  loading: {
    padding: "40px",
    textAlign: "center",
    fontSize: "18px",
  },
  summaryCards: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
    marginBottom: "40px",
  },
  card: {
    backgroundColor: "#ffffff",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    flex: "1 1 200px",
    textAlign: "center",
  },
  cardValue: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#4e79a7",
    marginTop: "8px",
  },
  section: {
    marginBottom: "60px",
  },
  chartCard: {
    backgroundColor: "#ffffff",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  },
  pieRow: {
    display: "flex",
    gap: "30px",
    flexWrap: "wrap",
    marginTop: "20px",
  },
  pieContainer: {
    flex: "1 1 300px",
    backgroundColor: "#ffffff",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  },
  tableWrapper: {
  overflowX: "auto",
  backgroundColor: "#ffffff",
  padding: "20px",
  borderRadius: "12px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
},
table: {
  width: "100%",
  borderCollapse: "collapse",
  textAlign: "left",
},
th: {
  backgroundColor: "#f0f4f8",
  padding: "12px",
  borderBottom: "2px solid #dee2e6",
  fontWeight: "bold",
},
td: {
  padding: "12px",
  borderBottom: "1px solid #e9ecef",
},

};

export default VolunteersPerformance;
